export default __webpack_public_path__ + "static/media/sa-girl.67f5c3b3.webp";